import { render, staticRenderFns } from "./CustomerNewButton.vue?vue&type=template&id=515dd1d1&scoped=true&"
import script from "./CustomerNewButton.vue?vue&type=script&lang=ts&"
export * from "./CustomerNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerNewButton.vue?vue&type=style&index=0&id=515dd1d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515dd1d1",
  null
  
)

export default component.exports